var DEFAULT_ORDER_LIMIT = DEFAULT_ORDER_LIMIT || 8;

if (typeof isEnglishLocale === 'undefined') {
  var isEnglishLocale = () =>
    (document.documentElement.lang || "").toLowerCase().startsWith("en");
}

if (typeof buildOrderLimitMessage === 'undefined') {
  var buildOrderLimitMessage = (limit, remaining = null) => {
    if (isEnglishLocale()) {
      if (remaining === null)
        return `You can only purchase up to ${limit} of this item.`;
      if (remaining <= 0)
        return `You have already reached the purchase limit of ${limit} for this item.`;
      return `You can only purchase up to ${limit} of this item. You can add ${remaining} more.`;
    }

    if (remaining === null)
      return `この商品は1商品につき${limit}個まで購入できます。`;
    if (remaining <= 0)
      return `この商品は1商品につき${limit}個まで購入できます。`;
    return `この商品は1商品につき${limit}個まで購入できます。あと${remaining}個まで追加できます。`;
  };
}

if (typeof buildOrderLimitLoginMessage === 'undefined') {
  var buildOrderLimitLoginMessage = () =>
    isEnglishLocale()
      ? "Please log in before purchasing this item."
      : "この商品を購入するにはログインしてください。";
}

if (typeof buildOrderLimitValidationMessage === 'undefined') {
  var buildOrderLimitValidationMessage = () =>
    isEnglishLocale()
      ? "We could not verify the purchase limit. Please try again."
      : "購入制限を確認できませんでした。時間をおいて再度お試しください。";
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        const idInput = this.form.querySelector("[name=id]");
        if (idInput) idInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.quantityInput = this.getQuantityInput();
        this.isSubmitting = false;
        this.syncQuantityLimit();
      }

      getOrderLimit() {
        const limit = parseInt(this.dataset.limit, 10);
        return Number.isFinite(limit) && limit > 0 ? limit : DEFAULT_ORDER_LIMIT;
      }

      getProductId() {
        const closestProductElement = this.closest("[data-product-id]");
        return (
          this.dataset.productId ||
          (closestProductElement ? closestProductElement.dataset.productId : "") ||
          ""
        );
      }

      getPurchasedQuantity(productId) {
        const directPurchasedQuantity = parseInt(this.dataset.purchased, 10);
        if (Number.isFinite(directPurchasedQuantity)) {
          return directPurchasedQuantity;
        }

        const purchasedByProduct = window.orderLimitPurchasedByProduct || {};
        const normalizedProductId = String(productId || "");
        const purchasedQuantity = parseInt(
          purchasedByProduct[normalizedProductId],
          10
        );

        return Number.isFinite(purchasedQuantity) ? purchasedQuantity : 0;
      }

      getLoginUrl() {
        if (this.dataset.loginUrl) return this.dataset.loginUrl;

        const returnUrl = encodeURIComponent(
          `${window.location.pathname}${window.location.search}`
        );
        return `/account/login?return_url=${returnUrl}`;
      }

      isCustomerLoggedIn() {
        return window.customerLoggedIn !== false;
      }

      getDesiredQuantity() {
        this.quantityInput = this.getQuantityInput();
        if (!this.quantityInput) return 1;

        const quantity = parseInt(this.quantityInput.value, 10);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      getQuantityInput() {
        const formElements = this.form && this.form.elements ? this.form.elements : null;
        const quantityField = formElements ? formElements.namedItem("quantity") : null;
        if (quantityField) {
          if (typeof quantityField.item === "function") {
            return quantityField.item(0);
          }
          return quantityField;
        }

        const formId = this.form ? this.form.id : null;
        if (!formId) return null;

        return document.querySelector(`input[name="quantity"][form="${formId}"]`);
      }

      isVariantAvailable() {
        if (this.dataset.variantAvailable === "false") return false;
        return !this.submitButton || !this.submitButton.disabled;
      }

      requiresActiveClass() {
        return (
          this.dataset.toggleActive === "true" ||
          (this.submitButton && this.submitButton.classList.contains("hover-btn"))
        );
      }

      syncSubmitButtonState(remainingLimit) {
        if (!this.submitButton) return;

        const canPurchase = this.isVariantAvailable() && remainingLimit > 0;

        if (this.requiresActiveClass()) {
          this.submitButton.classList.toggle("active", canPurchase);
        }

        if (this.isVariantAvailable()) {
          this.submitButton.classList.toggle("disable", !canPurchase);
        }
      }

      syncQuantityButtons() {
        if (!this.quantityInput) return;

        const quantityElement = this.quantityInput.closest("quantity-input");
        if (quantityElement && typeof quantityElement.validateQtyRules === "function") {
          quantityElement.validateQtyRules();
        }
      }

      getQuantityBaseMax(limit) {
        if (!this.quantityInput) return limit;

        const storedBaseMax = parseInt(this.quantityInput.dataset.orderLimitBaseMax, 10);
        if (Number.isFinite(storedBaseMax)) return storedBaseMax;

        const currentMax = parseInt(this.quantityInput.getAttribute("max"), 10);
        const baseMax = Number.isFinite(currentMax) ? currentMax : limit;
        this.quantityInput.dataset.orderLimitBaseMax = String(baseMax);
        return baseMax;
      }

      syncQuantityLimit() {
        const limit = this.getOrderLimit();
        const productId = this.getProductId();
        const purchasedQuantity = this.getPurchasedQuantity(productId);
        let nextMax = Math.max(0, limit - purchasedQuantity);

        if (this.quantityInput) {
          nextMax = Math.max(
            0,
            this.getQuantityBaseMax(limit) - purchasedQuantity
          );

          this.quantityInput.setAttribute("max", String(nextMax));
          if (this.getDesiredQuantity() > nextMax) {
            this.quantityInput.value = String(Math.max(1, nextMax));
          }

          this.syncQuantityButtons();
        }

        this.syncSubmitButtonState(nextMax);
      }

      async getCartQuantity(productId) {
        if (!productId) return 0;
        if (!window.routes || !window.routes.cart_url) return 0;

        const response = await fetch(`${window.routes.cart_url}.js`, {
          headers: { Accept: "application/json" },
        });

        if (!response.ok) {
          throw new Error(`Failed to load cart: ${response.status}`);
        }

        const cart = await response.json();
        return cart.items.reduce((total, item) => {
          return item.product_id === parseInt(productId, 10)
            ? total + item.quantity
            : total;
        }, 0);
      }

      async validateOrderLimit() {
        const productId = this.getProductId();
        if (!productId) return "";

        if (!this.isCustomerLoggedIn()) {
          return buildOrderLimitLoginMessage();
        }

        const limit = this.getOrderLimit();
        const desiredQuantity = this.getDesiredQuantity();
        const cartQuantity = await this.getCartQuantity(productId);
        const purchasedQuantity = this.getPurchasedQuantity(productId);
        const remaining = limit - cartQuantity - purchasedQuantity;

        if (remaining <= 0) return buildOrderLimitMessage(limit, 0);
        if (desiredQuantity > remaining)
          return buildOrderLimitMessage(limit, remaining);

        return "";
      }

      showOrderLimitError(errorMessage) {
        const hasInlineError = this.handleErrorMessage(errorMessage);
        if (!hasInlineError && errorMessage) {
          window.alert(errorMessage);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.isSubmitting ||
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.isSubmitting = true;
        this.submitButton.setAttribute("aria-disabled", true);
        this.handleErrorMessage();

        try {
          const orderLimitError = await this.validateOrderLimit();
          if (orderLimitError) {
            this.showOrderLimitError(orderLimitError);
            if (!this.isCustomerLoggedIn() && this.getProductId()) {
              window.location.href = this.getLoginUrl();
            }
            this.submitButton.removeAttribute("aria-disabled");
            this.isSubmitting = false;
            return;
          }
        } catch (error) {
          console.error("Order limit validation failed:", error);
          this.showOrderLimitError(buildOrderLimitValidationMessage());
          this.submitButton.removeAttribute("aria-disabled");
          this.isSubmitting = false;
          return;
        }

        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.set("quantity", String(this.getDesiredQuantity()));
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner")?.classList.add("hidden");
            this.isSubmitting = false;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return false;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return false;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        return true;
      }
    }
  );
}
